// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import HistoryButtons from './history_buttons';

export default HistoryButtons;
